module.exports = __webpack_public_path__ + "static/media/registp03_zhChs.13f6a6c6.png";